import { createSelector } from 'reselect'
import * as CardStatusRoles from 'const/CardStatusRoles'

const EMPTY_ARRAY = []

const createOverduePreviousCardsSelector = () => {
  return createSelector<{ cardId, cardRelations, previousCardsDates, cardStatusesById, boardsById, cardsById }, any, any[]>(
    [
      ({ cardId }) => cardId,
      ({ cardRelations }) => cardRelations,
      ({ previousCardsDates }) => previousCardsDates,
      ({ cardStatusesById }) => cardStatusesById,
      ({ boardsById }) => boardsById,
      ({ cardsById }) => cardsById,
    ],
    (
      cardId,
      cardRelations,
      previousCardsDates,
      cardStatusesById,
      boardsById,
      cardsById,
    ) => {
      const card = cardsById[cardId]

      if (!card || card.isArchived || card.isTemplate || boardsById[cardsById[cardId].boardId]?.isClosed || !cardRelations) return EMPTY_ARRAY

      return cardRelations?.predecessorIds.reduce((acc, childId) => {
        if (cardsById[childId]?.isArchived || cardsById[childId]?.isTemplate || boardsById[cardsById[childId]?.boardId]?.isClosed) return acc

        const cardDate = previousCardsDates?.find(cardDate => cardDate.id === childId)
        const cardRole = cardStatusesById[cardsById[childId]?.statusId]?.role

        if (
          cardDate?.dueDate &&
          Date.now() > cardDate.dueDate &&
          cardRole &&
          cardRole !== CardStatusRoles.NONE &&
          cardRole !== CardStatusRoles.COMPLETED
        ) {
          acc.push(childId)
        }

        return acc
      }, [])
    }   
  )
}

export default createOverduePreviousCardsSelector
